const form = `
  <div class="wizard-header" id="{{ wizardKey }}-header" ref="{{ wizardKey }}-header" >
    <div class="wizard-title">
      <span>{{ t(panels[currentPage].title) }}</span>
    </div>
    <div class="wizard-label">
      <span>{{ t(panels[currentPage].label) }}</span>
    </div>
    <div class="wizard-progress">
      <div
        class="wizard-progress-completed"
        style="width: {{ ((currentPage + 1) * 100) / panels.length }}%"
      ></div>
    </div>
  </div>
`;

export default form;
